import { LinkLabelCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedMappingLabel,
  MappingLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { replaceDeletedModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createDeletedModelConceptClass';
import { replaceDeletedResourceKey } from 'src/containers/ProjectDiagram/utils/resource/createDeletedResource';

export const replaceDeletedMappingLabelKey = (key: string) =>
  key.replace(
    new RegExp(`^${LinkLabelCategory.MAPPING_LABEL}-`),
    `${LinkLabelCategory.DELETED_MAPPING_LABEL}-`
  );

export const createDeletedMappingLabel = (
  existing: MappingLabel,
  deletedKeys: Set<string>
): DeletedMappingLabel => ({
  key: replaceDeletedMappingLabelKey(existing.key),
  from: deletedKeys.has(existing.from)
    ? replaceDeletedResourceKey(existing.from)
    : existing.from,
  value: existing.value,
  text: existing.text,
  to:
    existing.to && deletedKeys.has(existing.to)
      ? replaceDeletedModelConceptClassKey(existing.to)
      : existing.to,
  category: LinkLabelCategory.DELETED_MAPPING_LABEL,
});
